export const decodeJWTTokenPayload = token => JSON.parse(atob(token.split('.')[1]));